import React, { useState } from 'react';
import { HiHeart } from 'react-icons/hi2';
import LegalModal from './LegalModal';
import './Footer.css';

export default function Footer() {
  const [legal, setLegal] = useState(null); // 'privacy' | 'terms' | null

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__top">
          <div className="footer__brand">
            <div className="footer__logo">
              <img src="/favicon.svg" alt="StoreShot" width="32" height="32" />
              <span>StoreShot</span>
            </div>
            <p className="footer__tagline">
              High-conversion App Store screenshots.<br />
              For iOS, iPad & Android.
            </p>
          </div>

          <div className="footer__links">
            <div className="footer__col">
              <h4>Product</h4>
              <button onClick={() => scrollTo('features')}>How It Works</button>
              <button onClick={() => scrollTo('pricing')}>Pricing</button>
              <button onClick={() => scrollTo('reviews')}>Reviews</button>
            </div>
            <div className="footer__col">
              <h4>Support</h4>
              <button onClick={() => scrollTo('contact')}>Contact</button>
              <a href="mailto:hello@storeshot.io">Email</a>
            </div>
            <div className="footer__col">
              <h4>Legal</h4>
              <button onClick={() => setLegal('privacy')}>Privacy Policy</button>
              <button onClick={() => setLegal('terms')}>Terms of Service</button>
            </div>
          </div>
        </div>

        <div className="footer__bottom">
          <p>
            &copy; {new Date().getFullYear()} StoreShot.io by Kairos. All rights reserved. Made with <HiHeart className="footer__heart" /> for app developers.
          </p>
        </div>
      </div>

      {legal && <LegalModal type={legal} onClose={() => setLegal(null)} />}
    </footer>
  );
}
